<template>
<div class="editClientVue">
 <!-- Main Body Content area -->
        <div class="o-main-content-area o-main-content-area--padBotoomNone">
            <!-- Heading Section -->
            <div class="row c-responsive-fixwidth">
                <div class="col-md-12">
                    <h1 class="h1 text-center">Update Clients</h1>
                </div>
            </div>
            <!-- /Heading Section -->
        </div>
        <!-- /Main Body Content area -->

        <div class="o-ndividualArea c-responsive-fixwidth">
            <div class="col-md-6 col-md-offset-3">
                <div class="c-common-box-shadow o-super-client-area c-radius3 u-bg-white">
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Client:</label>
                                <input type="text" class="form-control" placeholder="e.g. John Doe" v-validate="{ required: true}" name="name" v-model="addClientList.display_name">
                                <span v-show="errors.has('name') && this.validation_err!=0" class="err-msg">{{ errors.first('name') }}</span>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Max User:</label>
                                <div class="o-cutsomSelect">
                                    <select  v-model="addClientList.max_user"
    v-validate="'required'" @blur="blur($event)" name="max_user" data-vv-delay="500">
                                        <option value="">— Select maximum users —</option>
                                        <option value="50">50 Free</option>                                                
                                        <option value="100">100</option>
                                        <option value="250">250</option>
                                        <option value="500">500</option>
                                        <option value="750">750</option>
                                        <option value="999999">Unlimited</option>
                                    </select>
                                    <span v-show="errors.has('max_user') && this.validation_err!=0" class="err-msg">{{ errors.first('max_user') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Admin Contact:</label>
                                <input type="text" class="form-control" placeholder="Admin Contact name" v-validate="{ required: true}" name="contact" v-model="addClientList.contact_person">
                                <span v-show="errors.has('contact') && this.validation_err!=0" class="err-msg">{{ errors.first('contact') }}</span>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Email ID:</label>
                                <input type="text" class="form-control" placeholder="Emial ID" v-validate="'email|required'" name="email" v-model="addClientList.email">
                                <span v-show="errors.has('email') && this.validation_err!=0" class="err-msg">{{ errors.first('email') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Phone:</label><!-- v-validate="{ required: true}" -->
                                <input type="number" class="form-control" placeholder="Enter phone number"  name="phone" v-model="addClientList.contact_phone">
                                <span v-show="errors.has('phone') && this.validation_err!=0" class="err-msg">{{ errors.first('phone') }}</span>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Subdomain:</label>
                                <input type="text" class="form-control" placeholder="Enter subdomain" v-validate="{ required: true}" name="subdomain" v-model="addClientList.subdomain">
                                <span v-show="errors.has('subdomain') && this.validation_err!=0" class="err-msg">{{ errors.first('subdomain') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group "><!-- v-validate="{ required: true}"  -->
                                <label class="common-label-text o-super-label">Billing Contact:</label>
                                <!-- <input type="text" class="form-control" placeholder="Add your billing contact name" name="billingContact" v-model="addClientList.billing_contact"> -->
                                <!-- <el-autocomplete
                                class="inline-input"
                                v-model="addClientList.billing_contact"
                                :fetch-suggestions="querySearch"
                                placeholder="Please Input"
                                @select="handleSelect"
                                ></el-autocomplete> -->
                                <el-select allow-create v-model="addClientList.billing_contact" @change="selectEmail()" style="width:100%;" filterable placeholder="Select Steward">
                                    <el-option
                                        v-for="(steward,index) in stewardsList"
                                        :key="index"
                                        :label="steward.last_name+', '+steward.first_name"
                                        v-validate="'required'"
                                        :value="steward.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                   
                        <div class="col-sm-6">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Billing Email:</label>
                                <input type="email" class="form-control" placeholder="Add your biling email" name="billingEmail" v-model="addClientList.billing_email">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Notes:</label>
                                <textarea class="form-control u-border-radius-0" rows="3" placeholder="Enter notes here" v-model="addClientList.note"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Alias Name:</label>
                                <input type="text" name="" class="form-control u-border-radius-0" placeholder="Alias Name" v-model="addClientList.alias_name">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group ">
                                <label class="common-label-text o-super-label">Short URL:</label>
                               <input type="text" name="" class="form-control u-border-radius-0" placeholder="Short URL" v-model="addClientList.short_url">
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <div class="text-center">
                                <ul class="o-filter-area">
                                    <li>
                                        <a href="javascript: void(0)" @click="backToList()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                    </li>
                                    <li>
                                        <a href="javascript: void(0)" @click="addClient()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
</div>

</template>
<script>
    import {
        bus
    } from '../../main';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';

    export default {
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                selectedClientId: 'selectedClientId'

            })
        },
        data() {
            return {
                validation_err: 0,
                addClientList: {
                    display_name: '',
                    max_user: '',
                    email: '',
                    contact_person: '',
                    contact_phone: '',
                    note: '',
                    billing_contact: '',
                    billing_email: '',
                    client_id: this.selectedClientId,
                    subdomain: '',
                    alias_name:'',
                    short_url:'',
                    tiny_url_id:'',
                },
                stewardsList: []
            };
        },
        methods: {
            addClient() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        //console.log("success");
                        this.validation_err = 0;
                        service.put('client/' + this.selectedClientId, this.addClientList, {
                                'Authorization': this.userToken
                            })
                            .then((client) => {
                                if (client.data.result.length == 0) {
                                    this.$message({
                                        type: 'error',
                                        message: 'Subdomain already exists'
                                    });
                                    this.addClientList.subdomain = '';
                                } else {
                                    this.$notify({
                                        title: this.$t('success'),
                                        message: 'Client Updated Successfully.',
                                        type: 'success'
                                    });
                                    this.$router.push({
                                        'path': '/clientList'
                                    });
                                }

                            }).catch((err) => {
                                console.log(err);
                                // if(err.status_message == 'Subdomian already exists')
                                // {
                                //   this.$message({
                                //       type: 'error',
                                //       message: 'Subdomain already exists'
                                //   });
                                //   this.addClientList.subdomain = '';
                                // }
                                // else
                                // {
                                this.$message({
                                    type: 'error',
                                    message: 'Something went wrong please try again later.'
                                });
                                this.addClientList.email = '';
                                // }

                            });
                    } else {
                        this.validation_err = 1;
                        // console.log("error");
                    }
                });
            },
            blur(event) {
                if ($(event.target).val() === "") {
                    $(event.target).siblings('.form-label').addClass('js-label-transition');
                    this.validation_err = 1;
                } else {
                    $(event.target).siblings('.form-label').removeClass('js-label-transition');
                    this.validation_err = 0;
                }
            },
            backToList() {
                this.$router.push({
                    'path': '/clientList'
                });
            },
            getStewardsList() {
                console.log("check stewards")
                service.get('employee/getStewards', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.addClientList.client_id
                    })
                    .then((stewards) => {
                        console.log(stewards);
                        this.stewardsList = stewards.data.result;
                        //console.log(this.stewards);
                    }).catch((err) => {
                        console.log(err);
                    });
            },
            querySearch(queryString, cb) {
                var links = this.stewardsList;
                var results = queryString ? links.filter(this.createFilter(queryString)) : links;
                // call callback function to return suggestions
                cb(results);
            },
            createFilter(queryString) {
                return (link) => {
                    return (link.first_name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelect(item) {
                console.log(item);
            },
            selectEmail() {
                console.log(this.addClientList.billing_contact)
                let index = this.stewardsList.findIndex((steward) => steward.id == this.addClientList.billing_contact)
                console.log(index);
                console.log("Hello check steward selection");
                if(index>=0) {
                    this.addClientList.billing_contact = this.stewardsList[index].first_name + ' ' + this.stewardsList[index].last_name;
                    this.addClientList.billing_email = this.stewardsList[index].email;
                }else{
                    this.addClientList.billing_email = '';
                }
            }
        },
        async created() {
            await service.get('client/' + this.selectedClientId, {
                    'Authorization': this.userToken
                })
                .then((client) => {
                    //console.log(client.data.result);
                    this.addClientList.display_name = client.data.result.user.display_name;
                    this.addClientList.max_user = client.data.result.max_user;
                    this.addClientList.email = client.data.result.user.email;
                    this.addClientList.contact_person = client.data.result.contact_person;
                    this.addClientList.contact_phone = client.data.result.contact_phone;
                    this.addClientList.note = client.data.result.note;
                    this.addClientList.billing_contact = client.data.result.billing_contact;
                    this.addClientList.billing_email = client.data.result.billing_email;
                    this.addClientList.client_id = client.data.result.id;
                    this.addClientList.subdomain = client.data.result.subdomain;
                    if(client.data.result.tiny_url && client.data.result.tiny_url.length>0){
                        this.addClientList.alias_name=client.data.result.tiny_url[0].name;
                        this.addClientList.short_url=client.data.result.tiny_url[0].short_url;
                        this.addClientList.tiny_url_id=client.data.result.tiny_url[0].id;    
                    }
                    this.getStewardsList();
                }).catch((err) => {
                    console.log(err);
                });
        }
    }

</script>
<style scoped>


</style>
